import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors as globalSelectors } from 'school-portal-reducer'
import { ExternalLink } from 'components'
import { buildInternalApiUrl } from 'utils'
import * as Types from 'types'
import { SurveyStepNav } from '../components'

const propTypes = {
  school: Types.school,
  surveySchoolYear: Types.schoolYear,
}

const defaultProps = {
  school: null,
  surveySchoolYear: null,
}

function CompleteConfirmation({ school, surveySchoolYear }) {
  const canDownload = !!(school && surveySchoolYear)
  const reportUrl =
    canDownload &&
    buildInternalApiUrl({
      url: `schools/${school.id}/survey_report.pdf`,
      query: { schoolYear: surveySchoolYear.id },
    })

  return (
    <section>
      <SurveyStepNav currentStepIndex={4} />
      <section className="content-block-container">
        <div className="card survey-complete">
          <h3 className="checkmark-heading">Survey Complete!</h3>
          <p>
            Thank you for completing this year's survey! Your responses help us
            paint a more comprehensive picture of arts education and can help us
            connect public schools such as yourselves with quality arts
            programs.
          </p>
          {canDownload && (
            <ExternalLink href={reportUrl} className="button-primary">
              Download your Survey Responses
            </ExternalLink>
          )}
        </div>
      </section>
    </section>
  )
}

CompleteConfirmation.propTypes = propTypes
CompleteConfirmation.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    school: globalSelectors.school(state),
    surveySchoolYear: globalSelectors.surveySchoolYear(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CompleteConfirmation
)
